import { ProjectOfflineService } from '~/sqlite/services/project';

export class ProjectLocalDataSource extends ProjectOfflineService {}

export const projectLocal = new ProjectLocalDataSource();
